// ======================================================================
// File Name       : SelectContentTypeDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Modal, Col, Button } from 'react-bootstrap';
import { MODAL_SIZE } from '../../../constants/index';
import RenderField from '../../../utils/ReduxFormUtils';


class SelectContentTypeDialog extends Component {

  render() {
    const { video, drill, document, link } = this.props;
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };

    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        size={MODAL_SIZE.md}
        style={style}
      >
        <Modal.Header onHide={this.props.onCancel} closeButton>
          <Modal.Title className="text-center">
            コンテンツ種別を選択してください
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="padding-10">
          <Col sm={12} className="padding-30">
            <Col sm={3}>
              <RenderField
                name="video"
                value={video}
                type="checkbox"
                label="ビデオ"
              />
            </Col>
            <Col sm={3}>
              <RenderField
                name="drill"
                value={drill}
                type="checkbox"
                label="ドリル"
              />
            </Col>
            <Col sm={3} className="padding-clear">
              <RenderField
                name="document"
                value={document}
                type="checkbox"
                label="ドキュメント"
              />
            </Col>
            <Col sm={3}>
              <RenderField
                name="link"
                value={link}
                type="checkbox"
                label="リンク"
              />
            </Col>
          </Col>
        </Modal.Body>

        <Modal.Footer className="text-center">
          <Button variant="default" className="btn-96 margin-10" onClick={this.props.onCancel}>
            キャンセル
          </Button>
          <Button variant="primary" className="btn-96 margin-10" onClick={this.props.onOK}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default SelectContentTypeDialog;
